"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoPlayLayer = void 0;
const pixi_js_1 = require("pixi.js");
const Constants_1 = require("../../Core/Constants");
const inversify_1 = require("inversify");
let AutoPlayLayer = class AutoPlayLayer extends pixi_js_1.Container {
    constructor() {
        super();
        const auto = new pixi_js_1.Text("AUTOPLAY", {
            fontSize: 52,
            fill: [0xffffff, 0x888888],
        });
        auto.blendMode = pixi_js_1.BLEND_MODES.ADD;
        auto.alpha = 0.3;
        auto.anchor.x = 0.5;
        auto.position.set(Constants_1.LayerWidth / 2, Constants_1.LayerHeight / 2);
        this.addChild(auto);
    }
};
AutoPlayLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [])
], AutoPlayLayer);
exports.AutoPlayLayer = AutoPlayLayer;
//# sourceMappingURL=AutoPlayLayer.js.map